import { z } from "zod";
import { AddressSchema } from "./Address";
import { notEmptyTextSchema } from "./Atoms";
import { PaymentTypeSchema } from "./Payment";

export const ProfileSchema = z.object({
	type: z.literal("Profile"),
	id: notEmptyTextSchema,
	companyId: notEmptyTextSchema,
	storeId: notEmptyTextSchema,
	tenantId: notEmptyTextSchema,
	// @deprecated
	clientType: z.enum(["user", "company"]),
	companyName: z.string().optional(),
	displayName: notEmptyTextSchema,
	email: z.string().email(),
	phoneNumber: z.string().optional(),
	address: AddressSchema.optional(),
	isAnonymous: z.boolean(),
	createdDate: z.number(),
	lastActivityDate: z.number(), //todo
	paymentType: PaymentTypeSchema.optional(),
	/** @deprecated Use organizationIds instead */
	organizationId: z.string().optional().nullable(),
	/** Array of organization IDs this user belongs to */
	organizationIds: z.array(z.string()).optional(),
});

export type TProfile = z.infer<typeof ProfileSchema>;
